// AmountChip — MD3 Chip с числом и валютой. Currency-aware formatting (RUB/USD/EUR/GBP —
// канон BE DealCurrency; V14 W8 §3.8.1: список ограничен каноном, GBP добавлен '£').
import { Chip } from '@mui/material';
import type { DealCurrency } from '@/api/deals';
import { formatMoney } from '@/lib/format';

interface AmountChipProps {
  /** Сумма (или null если не указана). */
  amount: number | null;
  /** Валюта. */
  currency: DealCurrency;
  /** Размер чипа. */
  size?: 'small' | 'medium';
}

/** MD3 Chip для отображения суммы сделки в указанной валюте. */
export function AmountChip({ amount, currency, size = 'small' }: AmountChipProps): JSX.Element {
  const label = formatMoney(amount, currency);
  return (
    <Chip
      data-testid="amount-chip"
      label={label}
      size={size}
      variant="outlined"
      title={amount === null ? 'Сумма не указана' : `${currency} ${amount}`}
    />
  );
}
